<template>
  <div id="purchase_point" class="section">
    <div class="columns">
      <div class="column is-half-desktop is-offset-one-quarter-desktop">
        <h1 class="subtitle">ドロン購入</h1>
        <p class="block">保有ドロン{{ doron }}pt</p>
        <p class="block">
          1ドロンにつき{{
            doronToYenRate
          }}円です。希望のドロン数を入力してください。
        </p>
        <b-field horizontal label="ドロン">
          <b-input
            v-model="purchaseAmount"
            type="number"
            required
            :message="
              amountIsValidated ? '' : '50 ~ 999999の間の数字を入れてください'
            "
          ></b-input>
        </b-field>
        <div class="has-text-centered mt-5">
          <button
            class="button is-primary"
            :disabled="!amountIsValidated"
            @click="onClickPurchase"
          >
            購入手続きをする
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DoronPurchaseFormModal from '@/components/DoronPurchaseFormModal';
export default {
  name: 'DoronPurchase',
  computed: {
    amountIsValidated() {
      return 50 <= this.purchaseAmount && this.purchaseAmount <= 999999;
    },
    doron: function () {
      return this.$store.getters['doron/doronAmount'];
    }
  },
  data() {
    return {
      purchaseAmount: 0,
      doronToYenRate: 1
    };
  },
  methods: {
    onClickPurchase() {
      this.$buefy.modal.open({
        parent: this,
        component: DoronPurchaseFormModal,
        hasModalCard: true,
        trapFocus: true,
        props: {
          doronAmount: Number(this.purchaseAmount),
          doronToYenRate: Number(this.doronToYenRate)
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
